
import React from 'react';
import Button from './Button';


export default function MicrosoftButton(props) {
    const { className, label, ...restProps } = props;

    return (
        <Button
            {...restProps}
            className={['btn', 'btn-primary', 'signInWithMicrosoftBtn', className].join(' ')}
        >
            <span className="imgMsLogin">
                <img src="./img/ms_logo.svg" alt={'ms_logo'} />
                {label}
            </span>
        </Button>
    );
}
